import { render, staticRenderFns } from "./ChatTextButtonImage.vue?vue&type=template&id=d4e9e008&scoped=true&"
import script from "./ChatTextButtonImage.vue?vue&type=script&lang=js&"
export * from "./ChatTextButtonImage.vue?vue&type=script&lang=js&"
import style0 from "./ChatTextButtonImage.vue?vue&type=style&index=0&id=d4e9e008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e9e008",
  null
  
)

export default component.exports